import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ExceptionList from '@app/pages/customer/exceptions/ExceptionList.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const ExceptionPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();

  return (
    <>
      <ResponsiveLayout title={tr('exceptions.exceptions', 'Exceptions')}>
        <ExceptionList />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(ExceptionPage);
